import React from 'react'

export default function Footer() {
  return (
    <div className='footer'>
      


<div className='footerTopBox'>

    <div className='footerPhoneNum'>
   

 
    <p>☎</p>
    1(516) 466-7570

    </div>

    <div className='footerAddressLink'>
      <p>📍</p>
    111 Great Neck Road, Suite 510, Great Neck, NY 11021
    <p className='websiteCredit'>Website rebuilt from the ground up in Reactjs by <a className='websiteCredit' href="https://github.com/ryanessel">Ryan Essel</a></p>
    </div>

    

    <div className='footerNcaSalesEmail'>
    <p>✉</p>
    sales@nishiyama-usa.com
    </div>

</div>

<br></br>
<br></br>



      
    </div>
  )
}
